import type { BrandingConfig } from '../types/branding.types';

const HEX_COLOR_REGEX = /^#[0-9a-fA-F]{6}$/;

export function hexToHsl(hex: string): string {
  if (!HEX_COLOR_REGEX.test(hex)) {
    return '0 0% 0%';
  }

  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      case b: h = ((r - g) / d + 4) / 6; break;
    }
  }

  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function applyBrandingToRoot(config: BrandingConfig): void {
  const root = document.documentElement;

  if (config.primaryColor) {
    const hsl = hexToHsl(config.primaryColor);
    root.style.setProperty('--primary', hsl);
    root.style.setProperty('--ring', hsl);
    root.style.setProperty('--brand-primary', hsl);
    root.style.setProperty('--brand-logo-bg', hsl);
  }

  if (config.secondaryColor) {
    root.style.setProperty('--brand-secondary', hexToHsl(config.secondaryColor));
  }

  if (config.accentColor) {
    root.style.setProperty('--brand-accent', hexToHsl(config.accentColor));
  }

  // Update favicon
  if (config.faviconUrl) {
    const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (link) link.href = config.faviconUrl;
  }

  // Update document title
  document.title = config.organizationName || 'Atriva';
}
